import React, { useState } from "react";
import CommonModal from "../../ResetContext/components/DumpModal";
import { Warning } from "@mui/icons-material";
import InputField from "../../ResetContext/components/InputField";
import Alert from "../../ResetContext/components/Alert";
import { useAppServices } from "../../../../../hook/services";
import { useUserInfo } from "../../../../../context/user";

const CancelConfirmModal = ({ isOpen, onClose }) => {
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const service = useAppServices();
  const userActiveLocation = useUserInfo()[4];
  const saveActiveLocation = useUserInfo()[5];

  const onConfirm = async () => {
    setLoading(true);
    const { response } = await service.subscription.cancelSubscription({
      payload: {
        subscription_id: userActiveLocation?.subscription_id,
        agency_id: userActiveLocation?.agency_id,
        account_id: userActiveLocation?._id,
      },
    });
    if (response?.success) {
      setLoading(false);
      saveActiveLocation(response?.account);
      onClose();
    } else {
      setLoading(false);
      alert("Something went wrong, please try again later.");
    }
  };
  return (
    <CommonModal title={""} isOpen={isOpen} onClose={onClose} showAlert={false}>
      <h4 className="text-xl font-semibold text-center mb-2">
        Cancel Your Plan
      </h4>
      <Alert
        icon={<Warning style={{ color: "#000000" }} />}
        text="You're about to cancel your plan. This action is permanent and cannot be
        undone."
        type="danger"
      />
      <div className="mt-4">
        <label htmlFor="confirm" className="text-gray-500 text-md">
          Type CONFIRM to proceed
        </label>
        <InputField
          id="confirm"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder={"Type CONFIRM to proceed"}
          classNames={"mt-2 focus:!border-gray-400"}
        />
        <button
          className={`mt-4 text-center w-full rounded-md py-3 text-lg ${
            input === "CONFIRM"
              ? "bg-black text-white"
              : "border !border-gray-300 bg-gray-100 text-gray-600"
          }`}
          onClick={onConfirm}
          disabled={loading || input !== "CONFIRM"}
        >
          {loading ? (
            <div className="w-full h-full flex items-center justify-center">
              <div
                class="spinner"
                style={{
                  width: "22px",
                  height: "22px",
                  display: "inline-block",
                  marginRight: "8px",
                }}
              ></div>
            </div>
          ) : (
            "Cancel plan"
          )}
        </button>
      </div>
    </CommonModal>
  );
};

export default CancelConfirmModal;
